import { render, staticRenderFns } from "./TitledCard.vue?vue&type=template&id=3a0c4da5&lang=pug"
import script from "./TitledCard.vue?vue&type=script&lang=js"
export * from "./TitledCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports